import React, { useEffect, useState } from "react";
import { useParams,useHistory } from "react-router-dom";
import "../css/readblog.css";
import ReactHtmlParser from "react-html-parser";
import ToTop from "./ToTop";

function ReadBlog(props) {
  const { slug } = useParams();
  const history=useHistory();
  const [blog, setBlog] = useState({});
  // const[currSlug,setCurrSlug]=useState();

  const getBlog = async (slug) => {
    props.setProgress(30);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}blog/slug/${slug}`
      );
      const data = await response.json();
      if(!data){
        return history.push("/notfound");
      }
      props.setProgress(80);
      // console.log(data.articles[0])
      setBlog(data.articles);
      document.title=`${data.articles.title} - BlogPoint`;
      props.setProgress(100);
    } catch (error) {
      window.location.href="/notfound"; //using this because history.push() didnot force to change route and showed undefined error in page
      return history.push("/notfound");
    }
    
  };
  useEffect(() => {
    props.setProgress(15);
    getBlog(slug);

    // console.log(blog);
    // eslint-disable-next-line 
  }, [slug]);

  return (
    <>
    <ToTop/>
      <div className="readblogcontainer">
        {/* date design  */}
        <div class="foldpaperdate">
          <div class="trianglepaper"></div>
          {blog.date?new Date(blog.date).toDateString():undefined}
        </div>

        {/* end of date design  */}

        <h1>{blog.title?blog.title.toUpperCase():undefined}</h1>
        <span className="authorname">{`- ${blog.author}`}</span>
        <div className="imagediv">
        <img className="coverimg"
          src={blog.imglink}
          height="300px"
          alt={blog.title + " img"}
        />
        </div>
        <div className="blogContent">{ReactHtmlParser(blog.article)}</div>
      </div>
    </>
  );
}

export default ReadBlog;
